// extracted by mini-css-extract-plugin
export default {"becomeMemberShip":"Fees_becomeMemberShip__Pd5JR"};